(ns rothko.panel.component
  (:require [rothko.component.core :refer [defcomp]]))

(defcomp panel
  {:type ::panel}
  [{:keys [appearance class select-fn]} & children]
  (let [class (cond-> (concat class appearance)
                select-fn (conj :selectable))
        props (cond-> {:class class}
                select-fn (assoc :on-click select-fn))]
    (into [:div.panel props] children)))
